import showModal from './showModal';
import showOverpanel from './showOverpanel';
import sendOverpanel from './sendOverpanel';
import closeOverpanel from './closeOverpanel';
import showAlert from './showAlert';
import { showLoadingModal, clearLoadingModal } from './loadingModal';
import setTitle from './setTitle';
import setParams from './setParams';
import clearParams from './clearParams';
import setFetching from './setFetching';
import printWindow from './printWindow';
import navigateTo from './navigateTo';
import keepAlive from './keepAlive';
import scrollToTop from './scrollToTop';
import openURL from './openURL';
import SDKMessageBus from '../utility/message-bus';
import notifyRefetchAccounts from './notifyRefetchAccounts';
import clearCache from './clearCache';
import logToServer from './logToServer';
import { IActions } from '../types';

export default function setupActions(
    messageBus: SDKMessageBus,
    moduleId: string,
    teardowns: (() => void)[],
    platformCapabilities: Set<string>,
    resizeIframe: () => void
): IActions {
    return {
        showOverpanel: showOverpanel(messageBus, moduleId, platformCapabilities),
        sendOverpanel: sendOverpanel(messageBus, moduleId, platformCapabilities),
        closeOverpanel: closeOverpanel(platformCapabilities),
        showModal: showModal(messageBus, platformCapabilities),
        showAlert: showAlert(platformCapabilities),
        navigateTo: navigateTo(platformCapabilities),
        setTitle: setTitle(moduleId, platformCapabilities),
        setParams: setParams(moduleId, platformCapabilities),
        clearParams: clearParams(moduleId, platformCapabilities),
        notifyRefetchAccounts: notifyRefetchAccounts(platformCapabilities),
        clearCache: clearCache(messageBus, platformCapabilities),
        showLoadingModal: showLoadingModal(platformCapabilities),
        clearLoadingModal: clearLoadingModal(platformCapabilities),
        setFetching: setFetching(moduleId),
        printWindow,
        logToServer: logToServer(platformCapabilities, moduleId),
        scrollToTop: scrollToTop(moduleId, platformCapabilities),
        openURL: openURL(platformCapabilities),
        keepAlive: keepAlive(platformCapabilities),
        resizeIframe
    };
}
